import { Module } from "vuex";
import { IFareManagementState } from "@/core/interfaces/state/fareManagementState.interface";
import { StoreState } from "@/store/type";

import mutations from "./mutations";
import actions from "./actions";
import state from "./state";
import getters from "./getters";

const fareManagementModule: Module<IFareManagementState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default fareManagementModule;
